(() => {
  const root = document.querySelector('.toypal-redesign');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  if (root.matches('[data-toypal-page="product"]')) {
    const toypalOneVariantId = '56739455041911';
    root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
      if (!input.value) input.value = toypalOneVariantId;
    });

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-direct-checkout]');
      if (!button) return;
      const form = button.closest('form');
      const variantId = form?.querySelector('[name="id"]')?.value || toypalOneVariantId;
      const quantity = Math.max(1, Number.parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
      const shopRoot = window.Shopify?.routes?.root || '/';
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(`${shopRoot}cart/${variantId}:${quantity}?checkout`);
    }, true);
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reducedData = navigator.connection && navigator.connection.saveData === true;
  const selectAll = (selector, scope = root) => [...scope.querySelectorAll(selector)];

  const header = root.querySelector('[data-header]');
  const updateHeader = () => header && header.classList.toggle('is-scrolled', window.scrollY > 12);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const menuButton = root.querySelector('[data-menu-button]');
  const menu = root.querySelector('[data-menu]');
  menuButton && menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menu && menu.classList.toggle('is-open', open);
  });
  menu && menu.addEventListener('click', event => {
    if (!event.target.closest('a')) return;
    menuButton && menuButton.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
  });

  const reveals = selectAll('.reveal');
  if (reducedMotion || !('IntersectionObserver' in window)) {
    reveals.forEach(item => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    reveals.forEach(item => observer.observe(item));
  }

  const deferredMedia = selectAll('[data-lazy-src], [data-lazy-poster]');
  const loadDeferredMedia = element => {
    if (element.dataset.lazySrc) {
      element.src = reducedMotion && element.dataset.reducedSrc ? element.dataset.reducedSrc : element.dataset.lazySrc;
      delete element.dataset.lazySrc;
      delete element.dataset.reducedSrc;
    }
    if (element.dataset.lazyPoster) {
      element.poster = element.dataset.lazyPoster;
      delete element.dataset.lazyPoster;
    }
  };
  if (!('IntersectionObserver' in window)) {
    deferredMedia.forEach(loadDeferredMedia);
  } else {
    const mediaObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        loadDeferredMedia(entry.target);
        mediaObserver.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    deferredMedia.forEach(element => mediaObserver.observe(element));
  }

  if (!reducedMotion && window.matchMedia('(pointer:fine)').matches) {
    selectAll('[data-tilt]').forEach(card => {
      card.addEventListener('pointermove', event => {
        const bounds = card.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        card.style.transform = `perspective(900px) rotateX(${-y * 4}deg) rotateY(${x * 5}deg)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  const scrollStory = root.querySelector('[data-scroll-story]');
  const chapters = selectAll('[data-scroll-chapter]');
  let storyFrame = 0;
  const updateScrollStory = () => {
    if (!scrollStory) return;
    const rect = scrollStory.getBoundingClientRect();
    const distance = Math.max(1, scrollStory.offsetHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, -rect.top / distance));
    const phase = progress < 0.25 ? 0 : progress < 0.75 ? 1 : 2;
    scrollStory.style.setProperty('--scroll', progress.toFixed(4));
    scrollStory.style.setProperty('--meter', `${(progress * 100).toFixed(1)}%`);
    scrollStory.dataset.phase = String(phase);
    chapters.forEach((chapter, index) => {
      chapter.classList.toggle('is-active', index === phase);
      chapter.classList.toggle('is-past', index < phase);
    });
    storyFrame = 0;
  };
  const requestStoryUpdate = () => {
    if (storyFrame) return;
    storyFrame = window.requestAnimationFrame(updateScrollStory);
  };
  if (scrollStory && !reducedMotion) {
    updateScrollStory();
    window.addEventListener('scroll', requestStoryUpdate, { passive: true });
    window.addEventListener('resize', requestStoryUpdate, { passive: true });
  }

  const heroVideo = root.querySelector('[data-hero-video]');
  if (reducedMotion || reducedData) heroVideo && heroVideo.pause();

  const dialog = root.querySelector('[data-demo-dialog]');
  const demoVideo = root.querySelector('[data-demo-video]');
  const demoMedia = root.querySelector('[data-demo-media]');
  const demoLoading = root.querySelector('[data-demo-loading]');
  const setDemoState = state => {
    if (!demoMedia) return;
    demoMedia.classList.toggle('has-frame', state === 'ready');
    demoMedia.classList.toggle('is-buffering', state === 'loading');
    demoMedia.classList.toggle('has-error', state === 'error');
    if (demoLoading) demoLoading.lastChild.textContent = state === 'error' ? ' The film could not load. Please close the player and try again.' : ' Preparing the film…';
  };
  ['loadeddata', 'canplay', 'playing'].forEach(name => demoVideo && demoVideo.addEventListener(name, () => setDemoState('ready')));
  ['waiting', 'stalled'].forEach(name => demoVideo && demoVideo.addEventListener(name, () => setDemoState('loading')));
  demoVideo && demoVideo.addEventListener('error', () => setDemoState('error'));
  const openDemo = () => {
    if (!dialog || !demoVideo) return;
    heroVideo && heroVideo.pause();
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    if (demoVideo.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
      setDemoState('loading');
      demoVideo.load();
    } else setDemoState('ready');
    demoVideo.play().catch(() => setDemoState('error'));
  };
  const closeDemo = () => {
    demoVideo && demoVideo.pause();
    if (dialog && typeof dialog.close === 'function') dialog.close(); else dialog && dialog.removeAttribute('open');
    if (!reducedMotion && !reducedData) heroVideo && heroVideo.play().catch(() => {});
  };
  selectAll('[data-demo-open]').forEach(button => button.addEventListener('click', openDemo));
  const closeButton = root.querySelector('[data-demo-close]');
  closeButton && closeButton.addEventListener('click', closeDemo);
  dialog && dialog.addEventListener('click', event => { if (event.target === dialog) closeDemo(); });

  const stage = root.querySelector('[data-step-stage]');
  const stageImage = root.querySelector('[data-stage-image]');
  const stageNumber = root.querySelector('[data-stage-number]');
  selectAll('[data-step]').forEach((button, index) => {
    button.addEventListener('click', () => {
      if (!stageImage || button.getAttribute('aria-pressed') === 'true') return;
      const media = stage && stage.querySelector('.stage-media');
      media && media.classList.add('is-changing');
      selectAll('[data-step]').forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      window.setTimeout(() => {
        stageImage.src = button.dataset.image;
        stageImage.alt = button.dataset.alt;
        stageImage.removeAttribute('srcset');
        if (stageNumber) stageNumber.textContent = String(index + 1).padStart(2, '0');
        media && media.classList.remove('is-changing');
      }, reducedMotion ? 0 : 220);
    });
  });

  const storybook = root.querySelector('.storybook');
  const storyImage = root.querySelector('[data-story-image]');
  const storyKicker = root.querySelector('[data-story-kicker]');
  const storyTitle = root.querySelector('[data-story-title]');
  const storyCopy = root.querySelector('[data-story-copy]');
  selectAll('[data-story]').forEach(button => {
    button.addEventListener('click', () => {
      storybook && storybook.classList.add('is-changing');
      selectAll('[data-story]').forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      window.setTimeout(() => {
        if (storyKicker) storyKicker.textContent = button.dataset.kicker;
        if (storyTitle) storyTitle.textContent = button.dataset.title;
        if (storyCopy) storyCopy.textContent = button.dataset.copy;
        if (storyImage) {
          storyImage.src = button.dataset.image;
          storyImage.alt = button.dataset.alt;
          storyImage.style.objectPosition = button.dataset.position;
          storyImage.removeAttribute('srcset');
        }
        storybook && storybook.classList.remove('is-changing');
      }, reducedMotion ? 0 : 220);
    });
  });

  const quotes = selectAll('.quote');
  const quoteCount = root.querySelector('[data-quote-count]');
  let quoteIndex = 0;
  const showQuote = index => {
    if (!quotes.length) return;
    quoteIndex = (index + quotes.length) % quotes.length;
    quotes.forEach((quote, itemIndex) => quote.classList.toggle('is-active', itemIndex === quoteIndex));
    if (quoteCount) quoteCount.textContent = `${quoteIndex + 1} / ${quotes.length}`;
  };
  const previousQuote = root.querySelector('[data-quote-prev]');
  const nextQuote = root.querySelector('[data-quote-next]');
  previousQuote && previousQuote.addEventListener('click', () => showQuote(quoteIndex - 1));
  nextQuote && nextQuote.addEventListener('click', () => showQuote(quoteIndex + 1));

  selectAll('.influencer-video-card video').forEach(video => {
    video.addEventListener('play', () => selectAll('.influencer-video-card video').forEach(other => { if (other !== video) other.pause(); }));
  });

  const productGallery = root.querySelector('[data-pdp-gallery]');
  if (productGallery) {
    const gallerySlides = selectAll('[data-gallery-slide]', productGallery);
    const galleryButtons = selectAll('[data-gallery-button]', productGallery);
    const galleryDialog = productGallery.querySelector('[data-gallery-dialog]');
    const lightboxImage = productGallery.querySelector('[data-gallery-lightbox-image]');
    let galleryIndex = 0;
    const renderGallery = index => {
      galleryIndex = (index + gallerySlides.length) % gallerySlides.length;
      gallerySlides.forEach((slide, slideIndex) => {
        const active = slideIndex === galleryIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      galleryButtons.forEach((item, buttonIndex) => {
        const active = buttonIndex === galleryIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      const activeImage = gallerySlides[galleryIndex]?.querySelector('img');
      if (activeImage && lightboxImage) {
        lightboxImage.src = activeImage.currentSrc || activeImage.src;
        lightboxImage.alt = activeImage.alt;
      }
    };
    const openLightbox = () => {
      if (!galleryDialog || !lightboxImage) return;
      renderGallery(galleryIndex);
      if (typeof galleryDialog.showModal === 'function') galleryDialog.showModal();
      else galleryDialog.setAttribute('open', '');
    };
    galleryButtons.forEach(button => button.addEventListener('click', () => renderGallery(Number(button.dataset.galleryButton))));
    productGallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => renderGallery(galleryIndex - 1));
    productGallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => renderGallery(galleryIndex + 1));
    gallerySlides.forEach(slide => slide.querySelector('img')?.addEventListener('click', openLightbox));
    productGallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => {
      if (galleryDialog && typeof galleryDialog.close === 'function') galleryDialog.close();
      else galleryDialog?.removeAttribute('open');
    });
    productGallery.querySelector('[data-gallery-lightbox-prev]')?.addEventListener('click', () => renderGallery(galleryIndex - 1));
    productGallery.querySelector('[data-gallery-lightbox-next]')?.addEventListener('click', () => renderGallery(galleryIndex + 1));
    galleryDialog?.addEventListener('click', event => { if (event.target === galleryDialog) galleryDialog.close?.(); });
    renderGallery(0);
  }

  const variantSelect = root.querySelector('[data-variant-select]');
  const variantPrice = root.querySelector('[data-variant-price]');
  const availability = root.querySelector('[data-availability]');
  const addButton = root.querySelector('[data-add-to-cart]');
  variantSelect && variantSelect.addEventListener('change', () => {
    const option = variantSelect.options[variantSelect.selectedIndex];
    const available = option.dataset.available === 'true';
    if (variantPrice) variantPrice.textContent = option.dataset.price;
    if (availability) availability.textContent = available ? 'In stock and ready to add to your cart.' : 'This option is currently unavailable.';
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'Add ToyPal One to cart' : 'Unavailable';
    }
  });
})();
